/**
 * @generated SignedSource<<06c19534e76758675be3fe49b870d0ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatThreadPurposeEnum = "applicant_feedback" | "hiring";
export type ChatThreadTypeEnum = "direct" | "group";
import { FragmentRefs } from "relay-runtime";
export type ChatThreadActions_Thread$data = {
  readonly id: string;
  readonly purpose: ChatThreadPurposeEnum | null | undefined;
  readonly recipient: {
    readonly " $fragmentSpreads": FragmentRefs<"ChatThreadActions_Recipient">;
  } | null | undefined;
  readonly threadType: ChatThreadTypeEnum;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadEditDialog_Thread">;
  readonly " $fragmentType": "ChatThreadActions_Thread";
};
export type ChatThreadActions_Thread$key = {
  readonly " $data"?: ChatThreadActions_Thread$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadActions_Thread">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadActions_Thread",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purpose",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatThreadEditDialog_Thread"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "recipient",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ChatThreadActions_Recipient"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatThread",
  "abstractKey": null
};

(node as any).hash = "c2ac595854b8baef9223ac4c21317f06";

export default node;
